import React from 'react';
import { useTranslation } from 'react-i18next';

import ControlButton from 'editor/src/component/ControlButton';
import IconMinus from 'editor/src/component/Icon/IconMinus';
import IconPlus from 'editor/src/component/Icon/IconPlus';

import { PREVIEW_MAX_SCALE, PREVIEW_MIN_SCALE } from './previewZoomMath';

import styles from './index.module.scss';

interface Props {
  scale: number;
  onZoomOut: () => void;
  onZoomIn: () => void;
  onReset: () => void;
}

function DesktopZoomControls({ scale, onZoomOut, onZoomIn, onReset }: Props) {
  const { t } = useTranslation();

  return (
    <div
      className={styles.desktopZoomControls}
      onMouseDown={(e) => e.stopPropagation()}
      // Clicking + quickly is not a double-click on the image.
      onDoubleClick={(e) => e.stopPropagation()}
    >
      <div title={t('editor-crop-zoom-out')}>
        <ControlButton
          onClick={onZoomOut}
          disabled={scale <= PREVIEW_MIN_SCALE}
          stopPropagation
          className="cy-preview-zoom-out"
        >
          <IconMinus />
        </ControlButton>
      </div>
      <div className={styles.bar} />
      <ControlButton onClick={onReset} stopPropagation className={`${styles.value} cy-preview-zoom-value`}>
        {`${Math.round(scale * 100)}%`}
      </ControlButton>
      <div className={styles.bar} />
      <div title={t('editor-crop-zoom-in')}>
        <ControlButton
          onClick={onZoomIn}
          disabled={scale >= PREVIEW_MAX_SCALE}
          stopPropagation
          className="cy-preview-zoom-in"
        >
          <IconPlus />
        </ControlButton>
      </div>
    </div>
  );
}

export default React.memo(DesktopZoomControls);
